import calendar from "./calendar";
import mobile from "./mobile";
import athlete from "./athlete";
import timezoneSelector from "./timezoneSelector";

export default{
    calendar,
    mobile,
    athlete,
    timezoneSelector
}
